export default __webpack_public_path__ + "static/Sticker_A5_USERS_LT_EN-f5c0868b21d202ac33d5321d2deef7e7.svg";